export const GET_ALL_WORKFLOW_REQUEST = 'GET_ALL_WORKFLOW_REQUEST';
export const GET_ALL_WORKFLOW_REQUEST_LOADING = 'GET_ALL_WORKFLOW_REQUEST_LOADING';
export const SET_WORKFLOW_REQUEST_COUNT = 'SET_WORKFLOW_REQUEST_COUNT';